(function () {
  'use strict';

  angular
    .module('AcaApp')
    .controller('IrsErrorReportController', IrsErrorReportController);

  IrsErrorReportController.$inject = [
    '$scope',
    '$mdDialog',
    'SendService',
    'UtilsService',
    'EmployerService',
    'CORRECTIONS_PAGE',
    'CorrectionService',
    'ParticipantService',
    '$location',
    'MsgBetweenCtrlService'
  ];
  
  function IrsErrorReportController(
    $scope,
    mdDialog,
    sendService,
    utilsService,
    employerService,
    CORRECTIONS_PAGE,
    correctionService,
    participantService,
    $location,
    msgBetweenCtrlService){
    var _this = this;

    /** properties */
    _this.correctionsPage = '';
    _this.employers = [];
    _this.errorReport = {};
    _this.errorReportsEmployers = [];
    _this.errorReportSubscribers = [];
    _this.selectedXmitRun = '';
    _this.tinWithMask = '';

    /** methods */
    _this.errorReportByXmit = _errorReportByXmit;
    _this.showPopupEmployers = _showPopupEmployers;
    _this.cancel = _cancel;
    _activate();

    /**
     * @private
     * @description Initialize the controller data.
     */
    function _activate(){
      _this.correctionsPage = CORRECTIONS_PAGE.CORRECTIONS;
      _this.errorReport = msgBetweenCtrlService.data;
      _setIrsError();
    }

    /** @private */
    function _setIrsError(){
      _this.errorReport.date = new Date(_this.errorReport.errordate);
      if(_this.errorReport.employers !== undefined){
        if(_this.errorReport.employers.length > 2){
          _this.errorReport.amountEmployers = _this.errorReport.employers.length - 2;
          _this.errorReport.showOthers = true;
        }
        else{
          _this.errorReport.amountEmployers = _this.errorReport.employers.length;
          _this.errorReport.showOthers = false;
        }

        _this.errorReport.employers.forEach(function(el){
          el.fullName = _getName(el.Pname) + ' ' + _getName(el.Pname2);
        });
      }
    }

    /** @public */
    function _errorReportByXmit(){
      $location.path('corrections');
    }

    /** @private */
    function _getName(argument){
      return argument || '';
    }

    /** @public */
    function _showPopupEmployers(action, xmitrun){
      $(xmitrun)[action]('slow');
    }

    /** @private */
    function _cancel(){
      msgBetweenCtrlService.clearData();
      mdDialog.cancel();
    }
  }
})();